"use client";

import { useState } from "react";
import type { EconomicEvent } from "@/vybe-trader-client/economic-calendar/types";
import { EventDetailsScreen } from "./components/EventDetails";
import EconomicCalendarView from "./EconomicCalendarView";

interface EconomicCalendarScreenProps {
  onBack: () => void;
}

export default function EconomicCalendarScreen({
  onBack,
}: EconomicCalendarScreenProps) {
  const [selectedEvent, setSelectedEvent] = useState<EconomicEvent | null>(
    null
  );

  if (selectedEvent) {
    return (
      <EventDetailsScreen
        event={selectedEvent}
        onBack={() => setSelectedEvent(null)}
      />
    );
  }

  return (
    <EconomicCalendarView
      variant="settings"
      onBack={onBack}
      onOpenEventDetail={(e) => setSelectedEvent(e)}
    />
  );
}
